var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationDashboardUnavailableIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.996,
    height: 24,
    viewBox: "0 0 19.996 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Notification",
    transform: "translate(-2.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39891",
    "data-name": "Path 39891",
    d: "M21.379,16.913A6.7,6.7,0,0,1,19,11.788V9a7.006,7.006,0,0,0-6-6.92V1a1,1,0,0,0-2,0V2.08A7,7,0,0,0,5,9v2.788a6.7,6.7,0,0,1-2.388,5.133A1.752,1.752,0,0,0,3.75,20h16.5a1.75,1.75,0,0,0,1.129-3.087ZM12,24a3.756,3.756,0,0,0,3.674-3H8.326A3.756,3.756,0,0,0,12,24Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationDashboardUnavailableIcon);
export default __webpack_public_path__ + "static/media/notification_dashboard_Unavailable_icon.cfbb8cde104303d84729f6c3d9552bed.svg";
export { ForwardRef as ReactComponent };